<header [ngStyle]="{ background: authService.currentUserValue.empresaCorPadrao }" id="header-enterprise">
  <figure class="principal">
    <img class="img" *ngIf="authService.currentUserValue != null"
    [src]="authService.currentUserValue.empresaMidiaRetangularCaminho | secure | async"
    [alt]="authService.currentUserValue.empresaNome">
    <figcaption class="nameEmpresa">
      <p><span>{{authService.currentUserValue.empresaNome}}</span></p>
    </figcaption>
  </figure>
  <aside ngbDropdown class="custom-dropdown">
    <button class="dots" id="dropdownConfig" ngbDropdownToggle (click)="($event)">
      Sair
    </button>
    <nav ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">

      <strong *ngIf="authService.currentUserValue.admin == true" ngbDropdownItem class="drop" (click)="gerenciar()">
        <span [data-feather]="'user'" [class]="'mr-50'"></span>
        Gerenciar
      </strong>

      <strong ngbDropdownItem class="drop logout" (click)="logout()">
        <span [data-feather]="'power'" [class]="'mr-50'"></span>
        Logout
      </strong>

    </nav>
  </aside>
</header>